<mat-card class="p-0 lc-card fx-column" [class]="'margins-' + size" [class.h-100]="stretchHeight" [class.no-box]="radioButtonTemplate" [class.w-100]="stretchWidth">
  @if (overlay) {
    <div class="loading-overlay text-center px-sm font-weight-500">
      {{ overlay }}
    </div>
  }

  <!-- Card Image-->
  @if (imageTemplate) {
    <div class="w-100 m-0" mat-card-image>
      <template [ngTemplateOutlet]="imageTemplate"></template>
    </div>
  }


  <mat-card-content class="m-0 p-0 fx-1-1" [ngClass]="contentClass">
    <!-- Card Header-->
    @if (headerTemplate || header) {
      <div class="header-container border-bottom">
        @if (header || subheader) {
          <div class="fx-column">
            @if (header) {
              <span class="mat-title font-weight-bold m-0 line-height-0 card-header">{{header}}</span>
            }
            @if (subheader) {
              <span class="mat-subheading-2 mat-hint m-0 line-height-0 card-subheader">{{subheader}}</span>
            }
          </div>
        }
        <template [ngTemplateOutlet]="headerTemplate"></template>
      </div>
    }

    <!-- Card Content-->
    @if (contentTemplate) {
      <div class="content-container" [class.pb-2]="!actionsTemplate && size==='sm'" [class.pb-4]="!actionsTemplate && size==='lg'" [ngClass]="contentClass">
        <template [ngTemplateOutlet]="contentTemplate"></template>
      </div>
    }

    <!-- Radio button Content-->
    @if (radioButtonTemplate) {
      <div class="header-container px-3">
        <template [ngTemplateOutlet]="radioButtonTemplate"></template>
      </div>
    }
  </mat-card-content>

  <!-- Divider (conditional upon content and actions)-->
  @if ((headerTemplate || header || subheader || contentTemplate) && actionsTemplate) {
    <mat-divider class="actions-divider position-relative" />
  }

  <!-- Card Content-->
  @if (actionsTemplate) {
    <mat-card-actions class="m-0">
      <template [ngTemplateOutlet]="actionsTemplate"></template>
    </mat-card-actions>
  }

  <!-- Spinner that overlays the entire card -->
  @if (loading?.isLoading) {
    <lc-spinner [showOverlay]="true" [spinnerText]="loading.loadingText" />
  }
</mat-card>
